import React, { createContext, useContext, useState, useEffect } from 'react';

const CarritoContext = createContext();

export const useCarrito = () => useContext(CarritoContext);

export const CarritoProvider = ({ children }) => {
  const [carrito, setCarrito] = useState([]);
  const [rol, setRol] = useState([]);
  const [IdUsuario, setIdUsuario] = useState([]);


  useEffect(() => {
    try {
      const carritoGuardado = localStorage.getItem('carrito');
      const rolGuardado = sessionStorage.getItem('rol');
      const idUsuarioGuardado = sessionStorage.getItem('IdUsuario');

      if (carritoGuardado) {
        const parsedCarrito = JSON.parse(carritoGuardado);
        if (Array.isArray(parsedCarrito)) {
          setCarrito(parsedCarrito);
        }
      }

      if (rolGuardado) {
        setRol(rolGuardado);
      }

      if (idUsuarioGuardado) {
        setIdUsuario(idUsuarioGuardado);
      }

    } catch (error) {
      console.error('Error al cargar datos desde localStorage:', error);
    } finally {
      setCarritoCargado(true);
    }
  }, []);

  useEffect(() => {
    if (rol) sessionStorage.setItem('rol', rol);
  }, [rol]);

  useEffect(() => {
    if (IdUsuario) sessionStorage.setItem('IdUsuario', IdUsuario);
  }, [IdUsuario]);


  const [carritoCargado, setCarritoCargado] = useState(false);

  useEffect(() => {
    try {
      const carritoGuardado = localStorage.getItem('carrito');
      if (carritoGuardado) {
        const parsedCarrito = JSON.parse(carritoGuardado);
        if (Array.isArray(parsedCarrito)) {
          setCarrito(parsedCarrito);
        }
      }
    } catch (error) {
      console.error('Error al leer el carrito desde localStorage:', error);
    } finally {
      setCarritoCargado(true);
    }
  }, []);
  
  useEffect(() => {
    if (carritoCargado) {
      localStorage.setItem('carrito', JSON.stringify(carrito));
    }
  }, [carrito, carritoCargado]);
  
  const agregarAlCarrito = (producto) => {
    setCarrito((prev) => {
      const existente = prev.find((item) => item.MSPN === producto.MSPN);
      if (existente) {
        return prev.map((item) =>
          item.MSPN === producto.MSPN
            ? { ...item, cantidad: item.cantidad + 1, existencias: producto.existencias }
            : item
        );
      }
      return [...prev, { ...producto, cantidad: 1, existencias: producto.existencias }];
    });
  };

  const limpiarCarrito = () => setCarrito([]);

  const totalCantidad = carrito.reduce((acc, item) => acc + item.cantidad, 0);
  const totalPrecio = carrito.reduce((acc, item) => acc + (item.precio * (item.cantidad || 1)), 0);

  const modificarCantidad = (MSPN, nuevaCantidad) => {
    if (Number.isInteger(nuevaCantidad) && nuevaCantidad > 0) {
      setCarrito((prev) =>
        prev.map((item) =>
          item.MSPN === MSPN ? { ...item, cantidad: nuevaCantidad } : item
        )
      );
    }
  };
  
  const eliminarDelCarrito = (MSPN) => {
    setCarrito((prev) => prev.filter((item) => item.MSPN !== MSPN));
  };

  return (
    <CarritoContext.Provider value={{ carrito, agregarAlCarrito, limpiarCarrito, totalCantidad, rol, setRol, modificarCantidad, eliminarDelCarrito, IdUsuario, setIdUsuario, totalPrecio }}>
      {children}
    </CarritoContext.Provider>
  );
};
